package org.multiplatform.kotfolio.pages.kids.exam.grade2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kids/exam/grade2/passage")
@Composable
fun Passages2() {
    BlogLayout(
        PageProperties(
            "English",
            ""
        ),
        BlogProperties("Grade 2", "Passage")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {

            SpanText(
                text = "Podar School Passage: 1",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the heart of our big, beautiful world, you will find a magical place called the rainforest. The rainforest is like a gigantic, colorful umbrella of green, filled with all sorts of fascinating plants and animals.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The rainforest has four different layers. Let's imagine we’re birds flying over  it. The first layer we see is the emergent layer. This is where the tallest trees, sometimes as tall as a 14 - story building, peek out. Eagles, bats, and butterflies like to hang out here.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Diving lower, we meet the canopy layer. This layer is full of umbrella- like trees that provide a roof for the rest of the rainforest. Creatures such as monkeys, frogs, and sloths call this layer home.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Next is the understory layer. This part is darker, as it’s shadowed by the canopy layer. You might find jaguars, leopards, and many insects here. The lowest layer is the forest floor. It's the darkest and coolest part of the rainforest, where the biggest animals like elephants and tigers live.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which is the magical place?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The rainforest is the magical place.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the name of the first layer?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The first layer is the emergent layer.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which creatures home is canopy layer? ",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The canopy layer is home to monkeys, frogs and sloths.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which are the four different layers of rainforest?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The four different layers of rainforest are emergent layer, canopy layer, understory layer and forest floor.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Podar school Passage: 2",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Once upon a time, in the heart of a thick forest, lived a little rabbit named Charlie. This forest was having a particularly harsh winter, and food was hard to find. Charlie' s family was hungry,and i t was up to Charlie to find food for them.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Charlie was a small rabbit, but he had a big heart. Despite the cold weather and deep snow, Charlie decided to venture out into   the forest. As he hopped through the snow, Charlie felt scared, but he knew he had to be brave for his family.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Deep in the forest, Charlie found a patch of berries. He    was about to grab some when he heard a growl. A large, scary wolf appeared. Charlie was terrified but knew he couldn't give up. He quickly hopped to a nearby hole and hid. The wolf waited for a while but eventually left.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Charlie gathered as many berries as he could carry and made the long journey home. He was t i red and cold, but the thought of his family kept him going. When he finally got back, his family was overjoyed. Charlie was a hero!",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who is Charlie?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Charlie was a small rabbit.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did Charlie find in the deep forest?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Charlie found a patch of berries.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why Charlie was terrified in the forest?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Charlie was terrified because a wolf appeared in the forest.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why Charlie was a hero?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Charlie was a hero because he brought berries for his family from the forest.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Podar School Passage: 3",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Amos and Elizabeth were walking to school. There was a lot of snow. It was 1885. They lived in Walnut Grove. They walked one mile to school every day. Amos was seven, and Elizabeth was 10. They were in the same class. All of the kids in the town were in the same class. There were 17 students. Their school only had one room. It was called a one-room schoolhouse. Amos started a fire in the big stove. It kept them warm on cold days. Lizzie cleaned the desks. Some desks were big, and some were small. They all sat in rows. Miss Laura put slates on all of the desks. She put chalk in the front of the room. Lizzie cleaned the board with a wet cloth. Miss Laura opened the book to the right page. The bell rang for school to start. All the children came to school. They put their coats on the hooks in the hall. They put their lunches down by their desks. They took the snow off their boots. All of the students stood up to say the pledge to the flag. The children then ate lunch and played games in the middle of the day. Some children played marbles. Others jumped rope and played clapping games. Some children ran races. Some played ball with sticks. When the day was over, the children got their books and walked home. ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How many rooms were there in the school?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "There were only one room in the school.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What makes them warm on cold days?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Amos use to start fire on the big stove so it makes them warm on cold days.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did all the students put their coat?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The students put their coat on the hook in the hall.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the children do in the middle of the day?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Children ate the lunch and play games in the middle of the school.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Which games did the children play in school?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Children play marbles, jumped rope, clapping games, running race and ball with sticks.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Podar School Passage: 4",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Once upon a time, there was a beautiful jungle. There lived a very big lion. He used to kill about 2-3 animals everyday for his meal. The animals were worried and went to discuss this with the lion. He agreed not to kill any animal if one of them itself comes to him everyday.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This went on for long. One day, it was the turn of a rabbit. A little rabbit agreed to go to the lion’s cage. As he was on his way, he saw an old well and planned to kill the lion. The little rabbit reached the lion’s den very late. The angry lion roared at the little rabbit and asked, “Why are you late?” The rabbit acted wisely and told the king that, “I met another lion on the way, which is bigger than you. It threatened to eat me.”",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The lion angrily asked the rabbit “Do you know where he lives?”. The rabbit replied ‘Yes’ and asked the king to follow him. The rabbit reached the old well and said the king, “That lion lives in this well.” The foolish lion peeped into the well and mistook his own reflection as another lion and roared loudly. The lion jumped into the well and drowned.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who killed animals for his meal?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The lion killed the animals for his meal.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did all the animals do",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The animals went to the lion.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the rabbit take the lion?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The rabbit took the lion to the old well.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the lion do after reaching the well?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The lion peeped into the well.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the lion jump?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The lion jumped into the well.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Podar School Passage: 5",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Jake is going on a trip. He and Mom take a taxi to the airport. “It’s my first plane trip,” he tells the taxi driver. “That’s great!” the taxi driver says. Jake rolls his suitcase onto the plane. “It’s my first plane trip,” he tells the pilot. “Welcome aboard,” the pilot says. Jake finds his seat and buckles his seatbelt. The plane’s engines rumble and roar. Jake opens his backpack and pulls out Panda. “It’s my first plane trip,” he whispers. He holds Panda’s paw. The plane moves faster and faster. Then—Whoosh! On the ground, cars and houses look like toys. Jake smiles. “Guess what, Panda?” he says. “Flying is fun!”",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do Jake and his mom travel to the airport?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "in a taxi",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What does a pilot do?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "A pilot flies a plane.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What does the pilot say to Jake?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The pilot said welcome aboard to Jake.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who is Panda?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "a stuffed animal",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What does Jake whisper to Panda?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Jake whispered to Panda that flying is fun.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 1: The Picnic Day",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "One Sunday morning, Aryan and his family went for a picnic in the park. They packed sandwiches, fruits, and juice in a basket. Aryan took his football to play. When they reached the park, they spread a mat under a tree and sat down. After eating, Aryan played with his father while his mother read a book. Birds chirped in the trees, and the cool breeze made the day pleasant. They came home in the evening, tired but very happy.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did Aryan and his family go?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "They went to the park for a picnic.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did Aryan take with him?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Aryan took his football.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did his mother do at the park?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "She read a book.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How was the weather?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The weather was pleasant and cool.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did they feel at the end of the day?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "They felt happy and tired.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 2: The Busy Ant",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Riya saw an ant carrying a grain of rice on its back. The grain was bigger than the ant, but it did not stop. It walked slowly and carefully along the garden path. Other ants followed it, each carrying food. Riya watched them for a while and was amazed at how hard they worked. She did not know ants worked in teams and helped each other. That day, she decided to work hard like the ants and help her mother at home.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What was the ant carrying?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "It was carrying a grain of rice.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did Riya learn?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Riya learned to work hard and help others.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What surprised Riya?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "She was surprised by how hard ants worked together.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who did Riya decide to help?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "She decided to help her mother.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How were the ants working?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The ants were working as a team.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 3: The Rainy Morning",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It was a rainy morning. The sky was grey, and the wind was blowing. Rohan wore his yellow raincoat and stepped out with an umbrella. On his way to school, he saw frogs jumping and puddles everywhere. The streets were wet, and the trees danced in the wind. Rohan reached school safely and dried his shoes near the classroom heater. He liked rainy days because they made everything look fresh and clean.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What colour was Rohan’s raincoat?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "It was yellow.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did he see on the way to school?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "He saw frogs and puddles.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did he dry his shoes?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "He dried his shoes near the heater.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the trees do in the wind?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "They danced in the wind.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did he like rainy days?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "He liked them because everything looked fresh and clean.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 4: The Helpful Girl",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Meera was walking home from school when she saw an old woman trying to cross the road. The traffic was busy, and no one stopped to help. Meera quickly went to the woman and asked if she needed help. Holding her hand, Meera helped her cross the road safely. The woman smiled and thanked her. Meera felt happy. When she told her mother about it, her mother hugged her and said she was proud of her.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who did Meera see?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "She saw an old woman.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What was the problem?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The woman was unable to cross the road.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did Meera help?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Meera helped her cross the road.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the woman do after crossing?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "She smiled and thanked Meera.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did Meera’s mother react?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "She hugged Meera and said she was proud.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 5: News Paper",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "As soon as the morning arrives, we eagerly wait for the newspaper. When the newspaper arrives, it feels as if our connection with the rest of the world has been restored. In ancient times, it used to take several days for news to travel from one place to another. Just imagine how people received news in those days. Primarily, travellers would carry news from one place to another. If any special event occurred, its news was delivered to people by special messengers. Kings and emperors had their personal messengers. When a messenger ran with bells tied to a stick, people would clear the way for him. If the news needed to be delivered quickly, horses were also used.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "If any special event occurred, its news was delivered to people by special ____________. Messengers",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "(A) Travelers, (B) Kings, (C) Messengers, (D) Horses",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "When the newspaper arrives, it feels as if our connection with ____________ has been restored. The world",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) The world, (B) The family, (C) Friends, (D) The village",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "In ancient times, it used to take ____________ news to travel from one place to another. Several",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) Several, (B) Two, (C) Three, (D) Four",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the antonym of the word 'horse'? Mare",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the synonym of the word 'run'? Sprit",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 6: Crawling Animal",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Snakes are classified as crawling animals. This group also includes crocodiles, lizards, and turtles. Snakes are found in forests, deserts, and lakes, etc. They cannot survive in places that are covered with snow throughout the year. Snakes have very weak vision. To avoid danger and find food, they use other senses. Some snakes smell with their nose, but most of them smell with their tongue. A snake's body is covered with scales made of layers of cells. Several times a year, a snake sheds its outer dead skin. The cells beneath immediately form a new outer layer, which protects the snake.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Snakes are classified as crawling ____________ animals. Crawling",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Snakes cannot survive in ____________.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the synonym of the word 'Category'? Level",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the antonym of the word 'most? Few",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "The word 'they' is ____________?. ",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 7: New Cycle",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sonam was staring at the new cycle on display at the shop. She was amazed to see the new shiny red cycle. Her father noticed it and said to her, 'Come along, we need to get going.' Sonam had a last look at the cycle and followed her father. She went to bed thinking about the shiny, red cycle. The next day she kept talking about the cycle to her friends in school. When she returned home, she noticed a new cycle parked near the gate. She screamed in joy calling out to her mother. Her parents came out smiling and told her that it was her birthday gift and gave her the cycle. Sonam was delighted and hugged her parents happily.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Sonam went with her ____________ to a shop.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) uncle, (B) father, (C) brother, (D) friends",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Sonam was attracted by the shiny ____________ cycle in the shop.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "The word 'amazed' means the same as: (B) Surprised",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "(A) remembered, (B) surprised, (C) shocked, (D) afraid",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 8: Ant",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ant came to the river to drink water, but slipped in and couldn't get out. The dove heard the ant's cries for help and dropped a leaf into the water, giving the ant a safe platform to climb onto and escape",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who came to the river to drink water?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "An ant came to the river to drink water.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What happened to the ant?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The ant slipped into the river and could not get out.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who heard the ant's cry for help?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "A dove, sitting on a nearby tree branch, heard the ant calling for help.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the dove do to save the life of the ant?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "The dove let fall a leaf over the water, allowing the ant to climb onto it and float to safety.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 9: Flower",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Flowers are useful to us in many ways. Flowers come in different colours and shapes. They are a symbol of beauty. Flowers are used in religious worship. Bouquets of flowers are given to show love and appreciation. Flowers are strung as garlands and used to adorn deities and honour celebrities. Flowers are arranged in vases to add beauty to our living environment.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Flowers have practical uses too. They are used to make perfumes, tea and cosmetic products. Certain flowers are used as medicines. In short, flowers are important because they have a positive impact on the body and the mind.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Flowers are ____________ to us in many ways. (B) useful",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) given (B) useful (C) sold (D) harmful",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Flowers are found in ____________. (C) different colours and shapes",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "(A) different shapes (B) many colours (C) different colours and shapes (D) a uniform size",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "The practical uses of flowers are: (A) making tea, perfumes and cosmetic products ",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) making tea, perfumes and cosmetic products (B) arranging in vases (C) making garlands (D) praying and worshipping",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "____________ flowers are used to make medicines. (B) Some",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) All (B) Some (C) Colourful (D) Small",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "The word 'impact means: (B) effect",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) force (B) effect (C) act (D) hit",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 10: Expressing gratitude",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Expressing gratitude is a great virtue which every human being should possess. It is a feeling whereby we express our thanks to someone. We can express our gratitude in various forms. We can be grateful in our thoughts, words, and actions. When we say 'Thank you', it means we are grateful. We should be grateful to everyone who is helpful to us. We should be grateful to God because 'He' has blessed us with many good things. We should say thanks to Him from the bottom of our heart.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Thank you' means that we are",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) superior (B) sad (C) miserable (D) grateful",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a great virtue?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) Expressing cruelty (B) Expressing gratitude (C) Expressing sorrow (D) Expressing misery",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "One can be grateful in one's ____________ also.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) virtues (B) duties (C) thoughts (D) earnings",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "'Helpful' is a/an ____________.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) noun (B) pronoun (C) verb (D) adjective",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "'Virtue' means ____________.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "(A) quality (B) heroism (C) evil (D) peace",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Passage 11: Language Gift",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Language is a wonderful gift given to man No animal possesses this gift, but they have their own way of expressing themselves. When a rabbit sees an enemy, it runs away into its hole. Its tail, which is white, bobs up and down as it runs. The other rabbits see it and they run too. They know that there is a danger. When a cobra is angry, it raises its hood and makes itself look dangerous. This warns the other animals When a bee has found some food, it goes back to the hive. It cannot tell the other bees where the food by speaking to them, but it does a kind of dance in the air. Some animals say things by making sounds. A dog barks when a stranger comes near.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Questions",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How is man different from animals?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "man has the gift of speech",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How does the rabbit give a signal of danger to other rabbits?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "it bobs its tail up and down as it runs",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How does a cobra warn the other animals?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "it raises its hood to look dangerous",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How does a bee communicate about food to other bees?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "it does a kind of a dance in the air",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "A dog barks when a stranger comes near. This is an example to show that -",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "some animals communicate by making some sounds",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }
        }
    }
}

//https://www.planetspark.in/english-grammar/unseen-passages-class-2
//https://www.scribd.com/document/799122877/unseen-passage-grade-2-grammar-magic
//https://infinitylearn.com/general-topics/unseen-passage-for-class-2
//studiestoday.com/assignment-english-cbse-class-2-english-read-passage-2-228822.html

/*
SpanText(
text = "Passage : ",
modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
.fontWeight(FontWeight.Bold)
)

Ul {
    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
        SpanText(
            text = "",
            modifier = Modifier.fontSize(FontSize.Medium)
        )
    }
}

SpanText(
text = "Questions",
modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
)

Ol {
    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
        Column {
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium)
            )
        }
    }

    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
        Column {
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium)
            )
        }
    }

    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
        Column {
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium)
            )
        }
    }

    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
        Column {
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium)
            )
        }
    }

    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
        Column {
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
            )
            SpanText(
                text = "",
                modifier = Modifier.fontSize(FontSize.Medium)
            )
        }
    }
}*/
